import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '../../common';

const StatusHeader = ({
  styles,
  lightPicture,
  calendarPicture,
  payNowLabel
}) => (
  <div className={styles['status-header__wrapper']}>
    <div className={styles['status-header__pay-now']}>
      <div />
      <Button
        id="page.status.component.status-header.status-button"
        className={styles['status-header__pay-now-button']}
      >
        {payNowLabel}
      </Button>
      <img
        src={lightPicture}
        alt="light-pic"
        className={styles['status-header__pay-now-lights']}
      />
    </div>
    <div className={styles['status-header__timeline']}>
      <img
        src={calendarPicture}
        alt="calendar"
        className={styles['status-header__timeline-img']}
      />
      <div className={styles['status-header__timeline-title']}>
        Deine Timeline
      </div>
      <div />
    </div>
  </div>
);

StatusHeader.propTypes = {
  styles: PropTypes.object,
  lightPicture: PropTypes.string,
  calendarPicture: PropTypes.string
};

export default StatusHeader;
